import React from 'react'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'

import { IconEdit } from '../../../../../../shared/icon/icon'
import { Menu, MenuRemove } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { RoleSelectUser } from '../../../../../../role/role-select/role-select-user'
import { useApiFormLoginUser } from '../../../../../../api-new/state/content'
import { useAuditRecord } from '../../../../../../shared/audit/history/audit-record-context'

export const OrganizationUserEdit = () => {
  const { url } = useRouteMatch()

  const { userID } = useParamsInt()

  const apiFormLoginUser = useApiFormLoginUser()

  const handlePath = () => apiFormLoginUser.get(`${userID}`)

  // History: whose membership this is, once loaded, for a reader without
  // SYS_AUDIT_LOG (record-routes.js recordOrg)
  const loaded = apiFormLoginUser.form.id === userID
  useAuditRecord({ type: 'users', id: loaded ? userID : undefined, organizationID: loaded ? apiFormLoginUser.form.organizationID : undefined })

  const HeaderMenu = () =>
    <Menu>
      <MenuRemove text="remove from organization" to={`${url}/delete/${userID}`} show pin />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormLoginUser.form.organizationName} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormLoginUser.form.organizationName} HeaderMenu={HeaderMenu}>
          <RoleSelectUser userID={userID} />
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
